import React from 'react';
import { motion } from 'framer-motion';
import { FaStar } from 'react-icons/fa';
import './HeroSection.css';

const HeroSection = () => {
  const scrollToForm = () => {
    const formSection = document.querySelector('.consultation-section');
    if (formSection) {
      formSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-background">
        <div className="microphone-illustration">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 0.3, scale: 1 }}
            transition={{ duration: 1.5, delay: 0.5 }}
            className="mic-glow"
          />
        </div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          {/* Trust Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="trust-badge"
          >
            <img 
              src="https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1757837789871rocket.png?generation=1757837786153025&alt=media" 
              alt="Rocket" 
              className="rocket-gif"
            />
            <span>Trusted by 1000+ aspiring singers</span>
          </motion.div>

          {/* Main Headline */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-headline"
          >
            <h1>
            Learn from Playback singers and  <br />
              <span className="highlight">Industry Experts</span>
            </h1>
          </motion.div>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="hero-description"
          >
            Transform your voice with personalized one-on-one coaching from professional singers and vocal coaches who've worked with top artists.
          </motion.p>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="hero-buttons"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="btn btn-primary"
              onClick={scrollToForm}
            >
              Get your Free Consultation
            </motion.button>
            {/* <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="btn btn-secondary"
            >
              Meet Our Experts
            </motion.button> */}
          </motion.div>

          {/* Social Proof */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="social-proof"
          >
            <div className="proof-item">
              <div className="coach-icons">
                {[
                  "https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/profile%2Fimage%2F17523085888811000023946.jpg?generation=1752308584383061&alt=media",
                  "https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/profile%2Fimage%2F17479916411221000244479.jpg?generation=1747991635014009&alt=media",
                  "https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/profile%2Fimage%2F17487116655391000247022.jpg?generation=1748711664519422&alt=media",
                  "https://storage.googleapis.com/download/storage/v1/b/ct-bucket-prod/o/1737697010957WhatsApp%20Image%202025-01-24%20at%2011.06.18%20AM.jpeg?generation=1737697010772675&alt=media"
                ].map((imageUrl, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5, delay: 1 + i * 0.1 }}
                    className="coach-icon"
                  >
                    <img 
                      src={imageUrl} 
                      alt={`Expert Coach ${i + 1}`}
                      className="coach-image"
                    />
                  </motion.div>
                ))}
              </div>
              <span>50+ Expert Coaches</span>
            </div>
            <div className="proof-item">
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, delay: 1.2 + i * 0.1 }}
                  >
                    <FaStar className="star-icon" />
                  </motion.div>
                ))}
              </div>
              <span>4.9/5 Average Rating</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
